import { Flex, Text, Box, IconButton, Icon, Divider, HStack, useMediaQuery, theme, Button } from '@chakra-ui/react';
import React from 'react';
import { GrFacebookOption } from 'react-icons/gr';
import { AiFillInstagram } from 'react-icons/ai';
import { FaTiktok, FaTwitter } from 'react-icons/fa';
import LocalizationSelector from 'Components/LocalizationSelector';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'Routes/AppRoutes';

interface IFooterProps{
	isBusiness?: boolean
}

export const Footer = ({isBusiness}:IFooterProps) => {
	const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
	const navigate = useNavigate();

	return (
		<Box px={{ base: '8', lg: '14', '2xl': '80px' }}  py={'60px'}>
			<Divider
				borderColor={'#C3C5C7'}
				variant={'solid'}
				size={'1px'}
			/>
			<Flex
				direction={['column', null, null, 'row']}
				pt={[6]}
				mb={[7, 8, null, 5]}
				alignItems={'center'}
				justifyContent={'space-between'}>
				<Text mb={['20px', null]} textAlign={'center'} fontSize={['12px', '16px']}>All rights reserved - Feed the Loop &copy; {new Date().getFullYear()}</Text>
				<HStack mb={['20px', null]} spacing={['20px', '50px']} >
					<Button cursor={'pointer'} onClick={() => {navigate(AppRoutes.privacyPolicy);}}
						fontSize={['12px', '16px']}
						fontWeight={'normal'}
					>
						Privacy
					</Button>
					<Button cursor={'pointer'} 
						onClick={() => {
							navigate( isBusiness ? AppRoutes.termsOfServiceBrands : AppRoutes.termsOfServiceUser);
						}}
						fontSize={['12px', '16px']}
						fontWeight={'normal'}
					>
						Terms & Conditions
					</Button>
				</HStack>
				<HStack spacing={'30px'} >
					<IconButton aria-label='facebook share' icon={<Icon as={GrFacebookOption} h={['14px', '20px']} w={['14px', '20px']} />} />
					<IconButton aria-label='insta share' icon={<Icon as={AiFillInstagram} h={['14px', '20px']} w={['14px', '20px']} />} />
					<IconButton aria-label='tiktok share' icon={<Icon as={FaTiktok} h={['14px', '20px']} w={['14px', '20px']} />} />
					<IconButton aria-label='twitter share' icon={<Icon as={FaTwitter} h={['14px', '20px']} w={['14px', '20px']} />} />
				</HStack>
			</Flex>
			<HStack
				justifyContent={{ base: 'center', lg: 'flex-start' }}
				width={'100%'}
			>
				<LocalizationSelector fontSize={isMobile ? '12px' : '16px'} direction='row' />
			</HStack>
		</Box>
	);
};